import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextButton } from '@components/library/button/index';
import {
  destroy as deleteRule,
  run as runRule } from '@api/v4/rules';

function RulesRow({ rule, setEditMode }) {
  const [deleteMode, toggleDeleteMode] = useState(false);
  const [isExecuting, setIsExecuting] = useState(false);

  const formatDate = (railsDate) => {
    const jsDate = new Date(railsDate);
    return railsDate
      ? `${jsDate.getMonth() + 1}/${jsDate.getDate()}/${jsDate.getFullYear().toString().substr(-2)}`
      : null;
  };

  const triggerRuleOnResource = () => {
    setIsExecuting(true);
    runRule(rule.key).then(() => {
      Notify.create({
        title: bfTranslate("Rule Executing"),
        type: "success"
      });
    }).catch(() => {
      setIsExecuting(false);
      Notify.create({
        title: bfTranslate("Failed to execute rule"),
        body: bfTranslate("Please try again."),
        type: "error"
      });
    });
  };

  const renderRule = () => {
    const { scopable_names, type, enforce, actionable_names, created_at, can_run } = rule;

    return (
      <React.Fragment>
        <span className="fifteen rule-name padding">
          { type }
        </span>
        <span className="twenty-five limited-height padding bf-scroll-element">
          { scopable_names }
        </span>
        <span className="fifteen limited-height padding bf-scroll-element">
          { actionable_names }
        </span>
        <span className="ten center">
          { enforce.toString() }
        </span>
        <span className="ten center">
          { formatDate(created_at) }
        </span>
        {BFG.currentUser?.su && (
          <span className="fifteen center">
            <button
              className="button secondary sm"
              disabled={isExecuting || !can_run}
              onClick={triggerRuleOnResource}
              type="button"
            >
              {bfTranslate("Execute")}
            </button>
          </span>
        )}
        <span className="five center">
          <TextButton
            className="edit-rule"
            onClick={() => setEditMode()}
            type="button"
          >
            <span className="bff-edit" />
          </TextButton>
        </span>
        <span className="five center">
          <button
            className="delete-rule"
            onClick={() => toggleDeleteMode(!deleteMode)}
            onKeyUp={() => toggleDeleteMode(!deleteMode)}
            type="button"
          >
            <span className=" bff-trash" />
          </button>
        </span>
      </React.Fragment>
    );
  };

  const deleteTags = () => {
    deleteRule(rule.key).then(() => {
      document.querySelectorAll("a.nav-link[href='rules']")[0].click();
      Notify.create({
        title: bfTranslate("Rule Removed"),
        type: "success"
      });
    }).catch(() => {
      Notify.create({
        title: bfTranslate("Deletion Failed"),
        body: bfTranslate("Please try again."),
        type: "error"
      });
    });
  };

  const renderDelete = () => (
    <div className="delete-rule-mode">
      <span className="delete-text">Are you sure you want to delete this rule?</span>
      <div className="delete-buttons">
        <button
          className="button tertiary md cancel"
          onClick={() => toggleDeleteMode(false)}
          type="button"
        >
          {bfTranslate("Cancel")}
        </button>
        <button
          className="button warning md"
          onClick={deleteTags}
          type="button"
        >
          {bfTranslate("Delete Rule")}
        </button>
      </div>
    </div>
  );

  return deleteMode ? renderDelete() : renderRule();
}

RulesRow.propTypes = {
  rule: PropTypes.shape({
    key: PropTypes.string,
    type: PropTypes.string,
    scope: PropTypes.object,
    enfore: PropTypes.bool,
    actionable_type: PropTypes.string,
    actionable_names: PropTypes.string,
    scopable_names: PropTypes.string,
  }).isRequired,
  setEditMode: PropTypes.func.isRequired
};

export default RulesRow;
